import React from "react";
import { Card, CardProps } from "react-bootstrap";

type IVCardProps = React.PropsWithChildren<CardProps> & {
    variant?: string;
};

const VCard = (props: IVCardProps) => {
    if (props.variant !== null) {
        // Emulate the bs3 well using card
        if (props.variant === "well") {
            return (
                <Card bg="light" body border={props.border} text={props.text}>
                    {props.children}
                </Card>
            );
        }
    }

    return (
        <Card
            bg={props.bg}
            body={props.body}
            border={props.border}
            text={props.text}
        >
            {props.children}
        </Card>
    );
};

export default VCard;
